import ListItemText from '@components/v2/ui/List/ListItemText';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import { Box } from '@mui/material';
import { HIGHLIGHT_MAX_WIDTH } from '../highlights.constants';
import HighlightUnreadIndicator from './HighlightUnreadIndicator';

interface HighlightMenuItemProps {
  title: string;
  isRead: boolean;
  testId?: string;
  onClick: () => void;
}

const HighlightMenuItem = ({ title, isRead, testId, onClick }: HighlightMenuItemProps) => (
  <MenuItem testId={testId} onClick={onClick}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        minWidth: 0,
        maxWidth: HIGHLIGHT_MAX_WIDTH,
      }}
    >
      {!isRead && <HighlightUnreadIndicator />}
      <ListItemText
        primary={title}
        slotProps={{
          primary: {
            variant: 'body2',
            noWrap: true,
            sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
          },
        }}
      />
    </Box>
  </MenuItem>
);

export default HighlightMenuItem;
